import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { MakeAxiosRequest } from "../../utils/handler";
import loaderFile from "../../Assets/Images/loader.gif";
import { noSpaceRegex, sidebarData } from "../../Constants";
import { Helmet } from "react-helmet";
import { fetchNotificationCount, logout } from "../../features/authSlice";
import dummyProfile from "../../Assets/Images/profile-default.png";
import Notifications from "./Notifications";
import ModalBox from "../modals/ModalBox";
import { useForm } from "react-hook-form";
import { SwalError, SwalSuccess } from "../SwalFns";
import helpcenterbg from "../../Assets/Images/helpcenterbg.png";
import EstimateDetails from "../../Pages/Estimates/EstimateDetails";
import InvoiceDetails from "../../Pages/Invoices/InvoiceDetails";
function Navbar() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();
  const [modalShow, setModalShow] = useState(false);
  const [detailsModal, setDetailShow] = useState(false);
  const [invoiceModal, setInvoiceShow] = useState(false);

  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const currentPath = location.pathname.split("/")[1];
  // Find the item in navbarTitle that matches the current route
  const currentNavItem = sidebarData.find((item) => item.link === currentPath);
  // Display the title from the matched item or a default value if not found
  const title = currentNavItem ? currentNavItem.title : "Page Not Found";
  const authUser = useSelector((state) => state?.auth?.user?.userDetails);
  console.log(authUser);
  const logoutUser = async () => {
    const response = await MakeAxiosRequest("post", "/logout");
    dispatch(logout());
    navigate("/login");
  };
  const [showNotifications, setShowNotifications] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState("");
  const [count, setCount] = useState("");
  const [invoiceKey, setInvoiceKey] = useState('');
  const [detailsUrl, setDetailsUrl] = useState("");
  const [shareLink,setShareLink] = useState("");

  const notificationCount = useSelector(
    (state) => state.auth.notificationCount
  );
  useEffect(() => {
    dispatch(fetchNotificationCount());
  }, []);
  const handleClose = () => {
    reset();
    setModalShow(false);
  };
  const closeModal = () => {
    
    setDetailShow(false);
  };
  const closeInvoiceModal = () => {
    
    setInvoiceShow(false);
  };
  const showModal = () => {
    setModalShow(true);
  };
  const submitContact = async (data) => {

    try {
      const response = await MakeAxiosRequest("post", "contactus/store", data);
      // console.log(response);
      if (response.status == 1) {
        handleClose();
        SwalSuccess({ msg: response.message });
      } else if (response.status == 0) {
        SwalError({ msg: response.message });
      } else {
        // setError('phone_number', { type: 'custom', message: response.message });
        console.log(response.message);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const getNotifications = async () => {
    setShowNotifications(false);
    dispatch(fetchNotificationCount());
    setIsLoaded(false);
    try {
      const response = await MakeAxiosRequest("post", "/notifications");
      // console.log(response)
      if (response.status == 1) {
        setIsLoaded(true);
        setShowNotifications(true);
        setData(response.data);
        setCount(response.totcount);
      } else {
        console.log(response);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };
  const toggleSidebar = () => {
    setSidebarVisible(!isSidebarVisible);
  };
  const [sideBarMenu, setSideBarMenu] = useState([]);
  useEffect(() => {
    setSideBarMenu(sidebarData);
  }, [data, sidebarData]);

  useEffect(() => {
    if (isSidebarVisible) {
      document.body.classList.remove("sidebar-toggled");
      document.getElementById("accordionSidebar").classList.remove("toggled");
    } else {
      document.body.classList.add("sidebar-toggled");
      document.getElementById("accordionSidebar").classList.add("toggled");
    }
  }, [isSidebarVisible]);

  useEffect(() => {
    console.log("Updated authUser:", authUser);
  }, [authUser]);
    const handleShow = async(key,type) => {
     
      try {
        const response = await MakeAxiosRequest("post", "/genaratewebtoken",{key:key,type:type});
        if (response.status == 1) {
            setDetailsUrl(response.data.redirectUrl);
            setInvoiceKey(key);
            setShareLink(response.data.invoiceUrl);
            if(type == 'estimatedetails'){
              setDetailShow(true);
            }else{
              setInvoiceShow(true);
            }
            
        } else {
            console.log(response);
        }
      } catch (error) {
          console.error("Error", error);
      }
      
      
    };
  if (authUser?.first_name) {
    return (
      <>
       
        <nav className="navbar navbar-expand navbar-light topbar static-top">
          <div className="d-flex align-items-center">
            <button
              id="sidebarToggleTop"
              className="btn btn-link d-md-none rounded-circle "
              onClick={toggleSidebar}
            >
              <i className="fa fa-bars"></i>
            </button>
            <Link key={authUser.org_image} className="sidebar-logo m-0 d-flex align-items-center ps-0" to='/dashboard'>
                  <img src={`${authUser.org_image}?v=${Date.now()}`} class="main_logo pe-3"/>
                  <p className="m-0 org-nav">{authUser.organization_name}</p>
               </Link>
            {/* {!/\/(customers|invoices)\/[^/]+/.test(location.pathname) && (
              <ul className="top-search">
                <li className="">
                  <form className=" form-inline  ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                    <div className="input-group">
                      <div className="input-group-append">
                        <button className="btn" type="button">
                          <i className="fas fa-search fa-sm"></i>
                        </button>
                      </div>
                      <input type="text" className="form-control border-0 small" placeholder="Search" aria-label="Search" aria-describedby="basic-addon2" />
                    </div>
                  </form>
                </li>

              </ul>
            )
            } */}
          </div>
          <div>
            <ul className="navbar-nav ml-auto align-items-center">
              <li className="ms-2">
                <div className="btn-group notification-sec dropdown-center">
                  <a
                    className="btn dropdown-toggle px-1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    onClick={getNotifications}
                  >
                    <span className="material-symbols-outlined">
                      notifications
                    </span>
                    {notificationCount == "0" || (
                      <span className="not-indication"></span>
                    )}
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end ">
                    {!isLoaded ? (
                      <div>
                        <center>
                          <img
                            src={loaderFile}
                            style={{ width: "100px" }}
                            alt="Loading..."
                          />
                        </center>
                      </div>
                    ) : (
                      showNotifications && (
                        <Notifications
                          notifications={data}
                          count={count}
                          handleShow={handleShow}
                        />
                      )
                    )}
                  </ul>
                  {/* <ul className="dropdown-menu dropdown-menu-end ">
                  <li className="notfctn-lst-hd d-flex justify-content-between flex-wrap px-3 py-2 border-bottom-0 align-items-end">
                    <h4 className="m-0">Notifications</h4>
                    <a href="" className="clear-all">Mark all read</a>
                  </li>
                  <li className="notfctn-lst px-3 py-2">
                    <a href="" className="d-flex align-items-baseline justify-content-between">
                      <div className="d-flex">

                        <div>
                          <h6>Invoice Overdue</h6>
                          <p>Invoice <span>INV/2024/06/234</span> is overdue by 5 days. Please follow up with <span>Alpha Ethical</span></p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="online-indctn"></span>

                      </div>
                    </a>
                  </li>
                  <li className="notfctn-lst px-3 py-2">
                    <a href="" className="d-flex align-items-baseline justify-content-between">
                      <div className="d-flex">

                        <div>
                          <h6>Invoice Due Soon</h6>
                          <p>Invoice <span> INV/2024/06/236</span> is due in 3 days. Make sure to remind <span>Auto Deal.</span></p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="online-indctn"></span>

                      </div>
                    </a>
                  </li>
                  <li className="notfctn-lst px-3 py-2">
                    <a href="" className="d-flex align-items-baseline justify-content-between">
                      <div className="d-flex">

                        <div>
                          <h6>New Feature Available!</h6>
                          <p>Check out our new feature that allows you to schedule invoices. Update your app now!</p>
                        </div>
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="online-indctn"></span>

                      </div>
                    </a>
                  </li>
                  <div className="text-end pt-2 px-3">
                    <a className="link small" href="">View All</a>
                  </div>
                </ul> */}
                </div>
              </li>
              <li className="ms-2">
                <div className="btn-group header-profile">
                  <a
                    className="btn dropdown-toggle px-1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <div className="profie-btn">
                    <img
                      key={authUser.profile_image}
                      className=""
                      src={authUser?.profile_image ? `${authUser.profile_image}?v=${Date.now()}` : dummyProfile}
                      alt="Profile Image"
                    />

                      <div className="pfl-drpup">
                        <h5>
                          {authUser?.first_name + " " + authUser?.last_name}
                        </h5>
                        <p className="m-0 nav-organization"> {authUser?.organization_name}</p>
                      </div>
                    </div>
                  </a>
                  <ul className="dropdown-menu dropdown-menu-end">
                    {/* <li className="nav-item">
                      <a className="nav-link d-flex align-items-center" href="javascript:void(0)">
                        <div className="profie-btn">
                          <img
                            className=""
                            src={authUser?.profile_image || dummyProfile}
                            alt=""
                          />
                          <div className="pfl-drpup d-block">
                            <h5>
                              {authUser?.first_name + " " + authUser?.last_name}
                            </h5>
                            <span> {authUser?.email}</span>
                          </div>
                        </div>
                      </a>
                    </li> */}
                    <li className="nav-item">
                      <a
                        className="nav-link d-flex align-items-center"
                        href="javascript:void(0)"
                        onClick={showModal}
                      >
                        <span className="material-symbols-outlined mx-2">
                          headset_mic
                        </span>
                        <p className="mb-0">Help Center</p>
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link d-flex align-items-center"
                        href="javascript:void(0)"
                        onClick={logoutUser}
                      >
                        <span className="material-symbols-outlined mx-2">
                          logout
                        </span>
                        <p className="mb-0">Logout</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <ModalBox
          isShow={modalShow}
          handleClose={handleClose}
          className="close-btn"
          modalSize="md"
          hasData={true}
        >
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <img src={helpcenterbg} class="img-fluid" />

                <h3 class="">How can we help you?</h3>
                <h6 class="gray mb-4 px-md-5 px-2">We are always here to help you. Please get in touch with us</h6>
                <form onSubmit={handleSubmit(submitContact)}>
                  <div class="form-group floating-label mt-4">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      {...register("subject", {
                        required: "Please enter subject",
                        pattern: {
                          value: noSpaceRegex,
                          message: "Please enter a valid subject",
                      },
                      })}
                    />
                    <label htmlFor="tax">Subject</label>
                    {errors.subject && (
                      <span className="error">{errors.subject.message}</span>
                    )}
                  </div>
                  <div class="form-group floating-label mt-4">
                    <input
                      type="text"
                      placeholder=""
                      className="form-control"
                      {...register("message", {
                        required: "Please enter message",
                        pattern: {
                          value: noSpaceRegex,
                          message: "Please enter a valid message",
                      },
                      })}
                    />
                    <label htmlFor="tax">Message</label>
                    {errors.message && (
                      <span className="error">{errors.message.message}</span>
                    )}
                  </div>
                  <div class="btnAlignBox">
                <button
                  type="button"
                  onClick={handleClose}
                  className="btn btn-outline-primary w-100"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary rounded-pill w-100 p-2"
                >
                  Send
                </button>
              </div>
                </form>
              </div>
             
            </div>
          </div>

        </ModalBox>
        {detailsModal && (
            <EstimateDetails
                showModal={detailsModal}
                handleClose={closeModal}
                invoiceKey={invoiceKey}
                url={detailsUrl}
                shareUrl={shareLink}
            />
        )}
         {invoiceModal && (
            <InvoiceDetails
                showModal={invoiceModal}
                handleClose={closeInvoiceModal}
                invoiceKey={invoiceKey}
                url={detailsUrl}
                shareUrl={shareLink}
            />
        )}
      </>
    );
  }
}

export default Navbar;
